import logo from './Barclays.svg';

const BarclaysLogo = () => {
    return <img src={logo} alt="Barclays logo" />;
};

BarclaysLogo.borderColor = '#ffffff';
BarclaysLogo.textColor = '#ffffff';
BarclaysLogo.backgroundColor = '#00afe9';

// eslint-disable-next-line import/no-default-export
export default BarclaysLogo;
